import { render, staticRenderFns } from "./card.vue?vue&type=template&id=df5b9396&scoped=true&"
import script from "./card.vue?vue&type=script&lang=ts&"
export * from "./card.vue?vue&type=script&lang=ts&"
import style0 from "./card.vue?vue&type=style&index=0&id=df5b9396&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5b9396",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
